import Image from 'next/image'
import { Button } from 'components/Button'
import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Content, ImageContainer, SignupRoot } from './Signup.styles'

import signupDog from '../../../../../../../public/assets/raw-food-subscription/signup-dog.webp'
import { Desktop } from 'components/Responsive/Mobile'

export const Signup = () => {
  const { t } = useTranslation()

  return (
    <SignupRoot>
      <ImageContainer>
        <Image src={signupDog} alt={t('raw-food-subscription:signup.alt')} />
      </ImageContainer>

      <Content>
        <Stack direction="column" gap="8">
          <Text as="h3" size="h3" weight="bold">
            {t('raw-food-subscription:signup.title')}
          </Text>

          <Desktop breakpoint="bp2">
            <Link href="/meal-plan" passHref>
              <Button as="a">{t('raw-food-subscription:signup.cta')}</Button>
            </Link>
          </Desktop>
        </Stack>
      </Content>
    </SignupRoot>
  )
}
